import { configureStore, ThunkAction } from '@reduxjs/toolkit';
import { Action } from 'redux';

import { tracklogApi } from 'ff/debrief/features/TracklogApi';
import { appSlice } from 'ff/debrief/features/AppSlice';
import { modalSlice } from 'ff/debrief/features/ModalSlice';
import { mapSlice } from 'ff/debrief/features/MapSlice';
import { chronoSlice } from 'ff/debrief/features/ChronoSlice';
import DebriefMapSettingPersistor from 'ff/debrief/features/DebriefMapSettingPersistor';

export const createStore = (
    options: { isShareApp?: boolean } = { isShareApp: false }
) => {
    return configureStore({
        preloadedState: {
            appSlice: {
                toast: { isOpen: false, message: '' },
                isShareApp: options.isShareApp,
                selectedSegment: null,
                isHidingScoreDetails: false,
                tracklogFilter: {
                    startDate: null,
                    endDate: null,
                    fuzzySearchTerm: '',
                },
            },
        },
        reducer: {
            appSlice: appSlice.reducer,
            modalSlice: modalSlice.reducer,
            mapSlice: mapSlice.reducer,
            chronoSlice: chronoSlice.reducer,
            [tracklogApi.reducerPath]: tracklogApi.reducer,
        },
        middleware: getDefaultMiddleware =>
            getDefaultMiddleware()
                .concat(tracklogApi.middleware)
                .concat(DebriefMapSettingPersistor.middleware),
    });
};

type store = ReturnType<typeof createStore>;
export type RootState = ReturnType<store['getState']>;
export type AppDispatch = store['dispatch'];

export type AppThunk<ReturnType = void> = ThunkAction<
    ReturnType,
    RootState,
    unknown,
    Action
>;
